<template>
  <div class="send-code-wrapper">
    <el-form-item :prop="prop" label="验证码">
      <el-input v-model="currentValue" :maxlength="4" placeholder="请输入"></el-input>
      <div class="send-box">
        <p class="line"></p>
        <p class="btn-send" v-if="getCodeBtn" @click="sendCode">{{ isFirst ? '重新获取' : '获取验证码' }}</p>
        <p class="btn-timer" v-else>{{ second }}s</p>
      </div>

      <p class="voice-code-box" v-if="voiceCodeBox">
        收不到验证码？立即使用
        <span class="voice-code" @click="sendVoiceCode">语音验证码</span>
      </p>
    </el-form-item>
  </div>
</template>
<script>
import { judgeMobile } from '@/util';

export default {
  name: 'sendCode',
  props: {
    prop: {
      type: String,
      default: 'verifyCode'
    },
    type: {
      default: 2
    },
    value: [String, Number], // v-model绑定的值
    mobile: {},
    isSendValidate: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    currentValue(newVal, oldVal) {
      this.$emit('input', newVal);
    }
  },
  data() {
    return {
      currentValue: '',
      getCodeBtn: true,
      second: 60,
      voiceCodeBox: false,
      isFirst: false
    };
  },
  methods: {
    async sendCode() {
      if (!judgeMobile(this.mobile)) {
        this.$message({
          message: '请输入正确手机号码',
          type: 'warning'
        });
        return;
      }
      // 发送验证码前的校验
      if (this.isSendValidate && this.$parent.sendCodeValidate) {
        let res = await this.$parent.sendCodeValidate();
        if (res) return;
      }
      Util.submitOnce(this._sendCode);
    },
    // 发送验证码
    async _sendCode() {
      let res = await Fetch.send_verify_code_by_type({ mobile: this.mobile, type: this.type });
      this.isFirst = true;
      this.$message('验证码发送成功');
      this.getCodeBtn = false;
      let timer = setInterval(() => {
        if (this.second == 30) {
          this.voiceCodeBox = true;
        }
        if (this.second === 1) {
          clearInterval(timer);
          this.getCodeBtn = true;
          this.voiceCodeBox = false;
          this.second = 60;
        }
        this.second--;
      }, 1000);
    },
    sendVoiceCode() {
      Util.submitOnce(this._sendVoiceCode);
    },
    async _sendVoiceCode() {
      let res = await Fetch.send_prescription_voice_verify_code({ mobile: this.mobile, type: this.type });
      this.$message('已发送，请患者注意接听来电');
      this.voiceCodeBox = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.send-code-wrapper {
  .send-box {
    display: flex;
    align-items: center;
    position: absolute;
    right: 0;
    top: 0;
    width: 104px;
    text-align: center;
    .line {
      height: 16px;
      width: 1px;
      margin-right: 10px;
      background-color: #f2f2f2;
    }
  }
  .voice-code-box {
    margin-top: 10px;
    line-height: 1.2;
    .voice-code {
      color: #ebb436;
    }
  }
}
</style>
